import { format } from 'date-fns';
import { StoreReviewDataType } from '../../../../types/StoreTypes';
import StarRating from '../../common/StarRating';
import S from './StoreReview.module.scss';
const StoreReview = ({
  review
}: {
  review: StoreReviewDataType;
}) => {
  const createdAt = new Date(review?.createdAt);
  createdAt.setMinutes(createdAt.getMinutes() - createdAt.getTimezoneOffset());
  return <div className={S.review_row} data-sentry-component="StoreReview" data-sentry-source-file="StoreReview.tsx">
      <div className={S.review_owner_wrapper}>
        <label>{review.player.finalMarketName}</label>
      </div>
      <div className={S.review_rating_wrapper}>
        <StarRating starMaxCount={5} filledCount={review.rating} starSize={13} isClickable={false} data-sentry-element="StarRating" data-sentry-source-file="StoreReview.tsx" />
        <label className={S.review_date}>
          {format(createdAt, 'yyyy-MM-dd')}
        </label>
      </div>
      <div className={S.review_text}>{review.text}</div>
    </div>;
};
export default StoreReview;